var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.68994L7 3.02327L13 1.68994V11.3932L7 12.7265L1 11.3932V1.68994ZM6.25 4.3932L2.5 3.55987V10.1899L6.25 11.0233V4.3932ZM7.75 11.0233L11.5 10.1899V3.55987L7.75 4.3932V11.0233Z",
    fill: "#2B2F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQs);
export default __webpack_public_path__ + "static/media/qs.7e8f6023fbe0655f970a4168c762b3f1.svg";
export { ForwardRef as ReactComponent };